var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.034,
    height: 65.034,
    viewBox: "0 0 65.034 65.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0.277)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 65.034,
    height: 65.034,
    rx: 12.89,
    transform: "translate(0 -0.277)",
    fill: "#92d4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M51.97,59.457H27.6a6.607,6.607,0,0,1-6.6-6.6V24.6A6.607,6.607,0,0,1,27.6,18H51.963a6.607,6.607,0,0,1,6.6,6.6V52.85a6.607,6.607,0,0,1-6.6,6.6ZM27.6,21.239A3.367,3.367,0,0,0,24.239,24.6V52.85A3.367,3.367,0,0,0,27.6,56.212H51.963a3.367,3.367,0,0,0,3.362-3.362V24.6a3.367,3.367,0,0,0-3.362-3.362Z",
    transform: "translate(-7.397 -6.36)",
    fill: "#00403b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M44.106,36.045a1.626,1.626,0,0,0-2.287-.136l-4.327,3.848-.959-1.7a1.617,1.617,0,1,0-2.818,1.587l1.943,3.453h0a2.013,2.013,0,0,0,.2.279l.039.039c.032.032.065.058.1.091a1.324,1.324,0,0,0,.214.162,1.05,1.05,0,0,0,.117.065,1.22,1.22,0,0,0,.253.1.707.707,0,0,0,.11.032,1.811,1.811,0,0,0,.376.052h.019a1.619,1.619,0,0,0,.35-.045c.032-.006.065-.019.1-.026a1.954,1.954,0,0,0,.291-.117l.045-.019s.013-.006.013-.013a1.783,1.783,0,0,0,.181-.123.808.808,0,0,0,.078-.058h.006l5.83-5.182a1.626,1.626,0,0,0,.136-2.287Z",
    transform: "translate(-11.802 -12.525)",
    fill: "#00403b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M44.106,54.045a1.626,1.626,0,0,0-2.287-.136l-4.327,3.848-.959-1.7a1.617,1.617,0,1,0-2.818,1.587l1.943,3.453h0a2.014,2.014,0,0,0,.2.279l.039.039c.032.032.065.058.1.091a1.324,1.324,0,0,0,.214.162,1.05,1.05,0,0,0,.117.065,1.22,1.22,0,0,0,.253.1.709.709,0,0,0,.11.032,1.811,1.811,0,0,0,.376.052h.019a1.619,1.619,0,0,0,.35-.045c.032-.006.065-.019.1-.026a1.954,1.954,0,0,0,.291-.117l.045-.019s.013-.006.013-.013a1.782,1.782,0,0,0,.181-.123.807.807,0,0,0,.078-.058h.006l5.83-5.182a1.626,1.626,0,0,0,.136-2.287Z",
    transform: "translate(-11.802 -18.865)",
    fill: "#00403b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.3de4b3f5501819ec0ab5181351624447.svg";
export { ForwardRef as ReactComponent };